"use client";

import { CtaComponentProps } from "@/cms/models";
import Link from "next/link";
import RippleCtaButton from "./RippleCtaButton";

export default function RippleCtaButtonComponent(props: {
  config: CtaComponentProps;
  id: string;
  itemIndex: number;
}) {
  return (
    <Link href={props.config.link}>
      <RippleCtaButton {...props}>{props.config.label}</RippleCtaButton>
    </Link>
  );
}
